/* Diamond Shine — Animation Framework (Sprint 1) */
/* MOBILE REVEAL FIX: IntersectionObserver threshold .15 -> 0 so description sections taller than a phone viewport still reveal. Added a load-time safety net so content is never permanently hidden. */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal(){
    var els = document.querySelectorAll('[data-ds-reveal]');
    if(!els.length) return;
    if(reduce || !('IntersectionObserver' in window)){
      els.forEach(function(e){ e.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold:0, rootMargin:'0px 0px -8% 0px' });
    els.forEach(function(e){ io.observe(e); });
    setTimeout(function(){
      els.forEach(function(e){
        var r = e.getBoundingClientRect();
        if(r.top < (window.innerHeight||0) && !e.classList.contains('is-visible')){ e.classList.add('is-visible'); }
      });
    }, 1800);
  }
  function shine(){
    if(reduce) return;
    var els = document.querySelectorAll('.ds-shine[data-ds-shine-auto]');
    if(!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('is-swept'); io.unobserve(en.target); }
      });
    }, { threshold:.5 });
    els.forEach(function(e){ io.observe(e); });
  }
  function init(){ reveal(); shine(); }
  if(document.readyState !== 'loading'){ init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();